<template>
<div class="select-list-wrapper">
  <header class="select-list-actions is-clearfix">
      <p class="control" v-if="selectedOptions.length > 0">
        <a href="#" role="button" class="button is-link clear-button" @click="clear"> Clear selected </a>
      </p>
      <p class="control">
        <input class="input" v-model="filterText" type="text" placeholder="Filter list">
      </p>
  </header>
  <div class="select-list" v-if="filteredOptions.length > 0">
    <MultiSelectToggle
            v-for="option in filteredOptions"
            :text="option.label"
            :value="option.value"
            :selected="option.selected"
            class="select-item"
            @toggle="onToggle($event)"
            ></MultiSelectToggle>
  </div>
  <div v-else>No items to display</div>
</div>
</template>

<script>

    import MultiSelectToggle from "./MultiSelectToggle";

    export default {
        name: "MultiSelectSelectList",
        components: {MultiSelectToggle,},
        data() {
            return {
                filterText: '',
                selectedOptions: this.selected
            }
        },
        props: ['options', 'selected'],
        methods: {
            onToggle(option) {

                if (option.selected) {

                    this.selectedOptions.push(option.value);
                } else {

                    this.selectedOptions.splice(this.selectedOptions.indexOf(option.value), 1);
                }
                console.log("CHANGED", this.selectedOptions);
                this.$emit('chosen', this.selectedOptions);

                this.$emit('change', {
                    changed: option,
                    selected: this.selectedOptions
                });
            },
            clear() {
                this.selectedOptions = [];
                this.$emit('change', {
                    changed: null,
                    selected: []
                });
            }
        },
        computed: {
            filteredOptions() {
                var visibleOptions = [],
                    filterText = this.filterText.trim().length > 0 ? this.filterText.toLowerCase() : null;
                let option_labels = []

                if (filterText) {

                    visibleOptions = this.options.filter((option) => {
                        let optWords = option.label.split(' ');

                        return optWords.some((word) => {
                            return word.toLowerCase().indexOf(filterText) === 0;
                        });
                    });
                    console.log("VISIBLE OPTIONS", visibleOptions)
                } else {

                    visibleOptions = this.options;
                    console.log("VISIBLE OPTION ELSE", visibleOptions)
                }

                return visibleOptions.map((option) => {
                    let label = '';

                    if (filterText) {
                        let searchStartIndex = option.label.toLowerCase().indexOf(filterText),
                            filterPart = option.label.substring(searchStartIndex, searchStartIndex + filterText.length);

                        label = option.label.replace(filterPart, `<b>${filterPart}</b>`);
                    } else {
                        label = option.label;
                    }

                    return {
                        value: option,
                        label,
                        selected: this.selectedOptions.includes(option)
                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">

.select-dropdown {
        $ver-padding: 10px;
        $hor-padding: 10px;
        position: relative;
        .select-dropdown-panel {
            $width: 760px;
            width: $width !important;
            max-width: $width;
            position: relative;
            top: calc(100% + 5px);
            left: calc(50%);
            transform: translateX(-50%);
            margin-bottom: 10px;
        }
        .select-list-wrapper {
            padding: $ver-padding $hor-padding;

        }
        .select-list-actions {
            padding: 0 $hor-padding $ver-padding;
            margin-bottom: $ver-padding;
            border-bottom: 1px solid rgba(0, 0, 0, .1);
            display: flex;
            justify-content: flex-end;
            .button.is-link {
                color: #7a7a7a;
                text-decoration: none;
            }
        }
        .select-list {
            margin-top: $ver-padding;
            display: flex;
            flex-wrap: wrap;
        }
        .select-item {
            flex-basis: 20%;
            margin-bottom: 1%;
            justify-content: flex-start;
        }
    }
.toggle-button {
    background: none;
    color: #7a7a7a;
    border: none;
    padding-left: 25px;
    position: relative;
    margin-left: 0 !important;
    transition: font-weight .1s ease-in;
    &:hover {}
    &:focus {
      box-shadow: none;
    }
    &.is-selected {
      color: #00D1B2;
      .fa {
        opacity: 1;
      }
    }
    .fa {
      position: absolute;
      left: 7px;
      font-size: 12px;
      opacity: 0;
      transition: opacity .1s ease-in;
    }
  }

.control{
    margin: 5px;
    padding-top: 10px;
    margin-top: auto;
    margin-bottom: auto;
}
    .clear-button{
        padding: 5px;
        margin: 10px;
        margin-top: 2px;
        border: 1px solid #00D1B2;
        border-radius: 20px;
    }
</style>
